export default {
    ren: '人',
    jiangong: '件，共',
    dingdanjine: '訂單金額',
    bubaohandandu: '此金額不包含單獨購買的輔營產品金額',
    shijizhifu: '實際支付',
    yincangquanbu: '隱藏全部',
    zhankaiquanbu: '展開全部',
    dingdanxiangqing: '訂單詳情',
    yizhifu: '已支付',
    caozuo: '操作',
    dingdanchuangjianshijian: '訂單創建日期',
    ewaixingli: '購買額外行李',
    tianjiaxingli: '添加行李服務',
    zanweigoumaifuyingchanpin: "暫未購買輔營產品",
    xinglixinxi: '行李資訊',
    buxuyao: '不需要',
    suoyouchengke: '所有乘客',
    weisuoyouchengkegoumai: '為所有乘客統一購買',
    weisuoyouchengkedandugoumai: '為每個乘客單獨購買',
    qucheng: '去程',
    huicheng: '回程',
    fujiafuwu: '附加服務',
    xinglizonge: '行李總價'
};